import React, { useRef } from 'react';

import Button, { BUTTON_MODE, BUTTON_SIZE } from '@components/Button';
import Portal from '@components/Portal';

import type { IButton } from '@components/Button';

import CloseIcon from '@assets/Icons/XSm';

import styles from './styles.module.scss';

export interface IModal {
  className?: string;
  onClose: () => void;
  children?: React.ReactNode;
  title?: React.ReactNode;
  footerExtra?: React.ReactNode;
  actions?: IButton[];
}

const Modal = ({ className = '', onClose, children, title, footerExtra, actions = [] }: IModal) => {
  const overlayRef = useRef<HTMLDivElement | null>(null);

  const overlayClickHandler = (event: React.MouseEvent) => {
    event.stopPropagation();
    if (overlayRef.current && event.target === overlayRef.current) {
      onClose();
    }
  };

  return (
    <Portal id="modal-root">
      <div ref={overlayRef} className={styles.overlay} onClick={overlayClickHandler}>
        <div className={`${styles.container} ${className}`}>
          <div className={styles.header}>
            <h6 className={styles.title}>{title}</h6>
            <Button mode={BUTTON_MODE.GHOST} size={BUTTON_SIZE.ICON_STANDARD} onClick={onClose}>
              <CloseIcon size={20} />
            </Button>
          </div>
          <div className={styles.body}>{children}</div>
          {(footerExtra || actions.length > 0) && (
            <div className={styles.footer}>
              <div className={styles.extra}>{footerExtra}</div>
              <div className={styles.actions}>
                {actions.map((buttonProps, index) => (
                  <Button key={index} {...buttonProps} />
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </Portal>
  );
};

export default Modal;
